<script>
  import { createEventDispatcher } from "svelte";
  import { DateValidator } from "../../../../Controller/analytics/DateValidator";
  import {
    analyticsFilters,
    applyFilters,
    presetRange,
    PRESETS,
  } from "../../../../stores/analyticsFilters";

  export let open = false;

  const dispatch = createEventDispatcher();

  let preset = $analyticsFilters.preset;
  let f1 = $analyticsFilters.f1;
  let f2 = $analyticsFilters.f2;
  let error = "";

  function pick(id) {
    preset = id;
    ({ f1, f2 } = presetRange(id));
    error = "";
    apply();
  }

  function edited() {
    preset = "custom";
    error = "";
  }

  function apply() {
    const res = DateValidator.validate(f1, f2);
    if (!res.valid) {
      error = res.errors[0];
      return;
    }
    error = "";
    applyFilters({ f1, f2 }, preset);
    dispatch("applied");
  }
</script>

<aside class="filters" class:open aria-label="Filtros">
  <div class="filters-head">
    <h2>Filtros</h2>
    <button
      type="button"
      class="filters-close"
      aria-label="Cerrar filtros"
      on:click={() => dispatch("close")}>×</button
    >
  </div>

  <p class="filters-note">Aplican a los tres dashboards.</p>

  <div class="presets" role="group" aria-label="Periodo">
    {#each PRESETS as p}
      <button
        type="button"
        class="preset"
        class:is-active={preset === p.id}
        on:click={() => pick(p.id)}>{p.label}</button
      >
    {/each}
  </div>

  <form on:submit|preventDefault={apply}>
    <label for="flt-f1">Desde</label>
    <input
      id="flt-f1"
      type="date"
      class="form-control"
      bind:value={f1}
      on:change={edited}
    />
    <label for="flt-f2">Hasta</label>
    <input
      id="flt-f2"
      type="date"
      class="form-control"
      bind:value={f2}
      on:change={edited}
    />
    {#if error}
      <p class="filters-error" role="alert">{error}</p>
    {/if}
    <button type="submit" class="apply">Aplicar</button>
  </form>
</aside>

<style>
  .filters {
    background: #fbf6ea;
    border: 1px solid rgba(44, 51, 32, 0.12);
    border-radius: 12px;
    padding: 0.9rem;
    font-size: 0.85rem;
  }

  .filters-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h2 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: #2c3320;
  }

  .filters-close {
    display: none;
    border: 0;
    background: transparent;
    font-size: 1.5rem;
    line-height: 1;
    color: #57543f;
  }

  .filters-note {
    margin: 0.2rem 0 0.7rem;
    font-size: 0.75rem;
    color: #83805f;
  }

  .presets {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-bottom: 0.9rem;
  }

  .preset {
    border: 1px solid rgba(44, 51, 32, 0.18);
    background: transparent;
    color: #57543f;
    border-radius: 999px;
    padding: 0.2rem 0.65rem;
    font-size: 0.78rem;
    font-weight: 600;
  }

  .preset.is-active {
    background: #2c3320;
    border-color: #2c3320;
    color: #fbf6ea;
  }

  label {
    display: block;
    margin: 0.5rem 0 0.15rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #57543f;
  }

  .form-control {
    height: 2.1rem;
    font-size: 0.85rem;
  }

  .apply {
    width: 100%;
    margin-top: 0.9rem;
    border: 0;
    border-radius: 10px;
    background: #2c3320;
    color: #fbf6ea;
    padding: 0.55rem 1rem;
    font-size: 0.85rem;
    font-weight: 700;
    transition: background 0.15s ease;
  }

  .apply:hover {
    background: #4c5a34;
  }

  .apply:focus-visible {
    outline: 2px solid #ce5b34;
    outline-offset: 2px;
  }

  .filters-error {
    margin: 0.4rem 0 0;
    font-size: 0.75rem;
    color: #b14b2c;
  }

  @media (max-width: 991px) {
    .filters {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1050;
      width: min(320px, 88vw);
      border-radius: 12px 0 0 12px;
      overflow-y: auto;
      transform: translateX(100%);
      transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
      visibility: hidden;
    }

    .filters.open {
      transform: none;
      visibility: visible;
      box-shadow: -8px 0 24px rgba(44, 51, 32, 0.18);
    }

    .filters-close {
      display: block;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .filters {
      transition: none;
    }
  }
</style>
